import { useQuery } from '@tanstack/react-query';
import SupportAllowedTypeFields from '../models/supportAllowedTypeFields';
import useRestService from '../shared/rest-service';

export function useSupportFields() {
  const { fetchWrapper } = useRestService();

  return useQuery<
    SupportAllowedTypeFields[],
    Error,
    { requestTypeFields: SupportAllowedTypeFields[]; initialHiddenFields: { key: string; value: string[] }[] }
  >(
    ['support-allowed-fields'],
    () => {
      return fetchWrapper('api/management/support/request-type-fields');
    },
    {
      staleTime: Infinity,
      select: (data) => {
        return {
          requestTypeFields: data,
          initialHiddenFields: data.map((field) => ({ key: field.value, value: [] }))
        };
      }
    }
  );
}
